// Client-side preferences storage using cookies (SameSite=Lax + Secure on HTTPS).
// These values are non-sensitive (language, theme, chat session id), but cookies
// avoid bulk-readable localStorage dumps in case of XSS, and are partitioned by origin.
//
// Cookies cannot be HttpOnly (HttpOnly is server-set only) — for true XSS isolation
// of session cookies, see backend httpOnly auth cookies handled by FastAPI.

const ONE_YEAR_S = 60 * 60 * 24 * 365;

function isSecure() {
  try { return typeof window !== "undefined" && window.location?.protocol === "https:"; }
  catch { return false; }
}

export function readPref(key, fallback = "") {
  if (typeof document === "undefined") return fallback;
  const target = `${encodeURIComponent(key)}=`;
  const parts = document.cookie ? document.cookie.split("; ") : [];
  for (const c of parts) {
    if (c.startsWith(target)) {
      try { return decodeURIComponent(c.slice(target.length)); }
      catch { return fallback; }
    }
  }
  return fallback;
}

export function writePref(key, value, maxAgeSeconds = ONE_YEAR_S) {
  if (typeof document === "undefined") return;
  const v = value == null ? "" : String(value);
  const flags = [
    `${encodeURIComponent(key)}=${encodeURIComponent(v)}`,
    `Max-Age=${maxAgeSeconds}`,
    "Path=/",
    "SameSite=Lax",
  ];
  if (isSecure()) flags.push("Secure");
  document.cookie = flags.join("; ");
}
